export const PortfolioData = [
  {
    id: 2,
    name: "Simple Food Review app",
    image: "https://i.ibb.co/379WQdd/full-Stack-Img1.png",
    link: "https://zero-one-service.web.app/",
    github: "https://github.com/UhaiMong/service-review-client-repo.git",
  },
  {
    id: 3,
    name: "Contest Club design",
    image: "https://i.ibb.co/KhN4fhY/design-Img2.png",
    link: "https://serene-valkyrie-92e5f3.netlify.app/",
    github: "https://github.com/UhaiMong/contest-club-repo.git",
  },
  {
    id: 3,
    name: "Simple quiz app",
    image: "https://i.ibb.co/ZTxZmTp/design-Img3.png",
    link: "https://learn-yourself-5b6c4.web.app/",
    github: "https://github.com/UhaiMong/quiz-app-client-repo.git",
  },
  {
    id: 2,
    name: "Products resale site",
    image: "https://i.ibb.co/gTPgj62/full-Stack-Img2.png",
    link: "https://smart-resale-stall.web.app/",
    github: "https://github.com/UhaiMong/smart-resale-stall-repo.git",
  },
  {
    id: 2,
    name: "Doctor Portal Web App",
    image: "https://i.ibb.co/sWCHMPB/full-Stack-Img3.png",
    link: "https://doctor-portal-client-745da.web.app/",
    github: "https://github.com/UhaiMong/doctor-portal.git",
  },
  {
    id: 3,
    name: "Online Course Cart Design",
    image: "https://i.ibb.co/QC5YGtx/design-Img1.png",
    link: "https://cerulean-platypus-da1cbf.netlify.app/",
    github: "",
  },
];
